import { useGlobalContentStore } from '~/store/globalContent';
import useLinkReplacer from '~/composeables/useLinkReplacer';
import useStoryblokAdmin from '~/composeables/useStoryblokAdmin';

export default defineNuxtRouteMiddleware((to) => {
  const globalContent = useGlobalContentStore();
  const { isInStoryblokAdmin } = useStoryblokAdmin();
  const { homeUrl, manualUrl } = useLinkReplacer();

  if (isInStoryblokAdmin(to)) {
    return;
  }

  const path = to.path?.replace(/\/?$/, '/');
  if (!globalContent.getB2cEnabled && path === globalContent.getB2cStartpagePath) {
    return navigateTo(manualUrl(globalContent.getB2bStartpagePath));
  }
  if (!globalContent.getHasDifferentEndConsumerTypes) {
    return;
  }

  if (globalContent.getIsB2b && path === globalContent.getB2cStartpagePath) {
    return navigateTo(homeUrl());
  } else if (globalContent.getIsB2c && path === globalContent.getB2bStartpagePath) {
    return navigateTo(homeUrl());
  }
});
